export const actionTypes = {
    GET_ASSET_OVERVIEW: 'powertrainAssetsOverviewV2/GET_ASSET_OVERVIEW',
    GET_ASSET_GROUP_OVERVIEW: 'powertrainAssetsOverviewV2/GET_ASSET_GROUP_OVERVIEW',
    GET_POWERTRAIN_OVERVIEW: 'powertrainAssetsOverviewV2/GET_POWERTRAIN_OVERVIEW',
    GET_SUBSCRIPTION_TYPES: 'powertrainAssetsOverviewV2/GET_SUBSCRIPTION_TYPES',
    GET_SUBSCRIPTION_TYPES_SETTINGS: 'powertrainAssetsOverviewV2/GET_SUBSCRIPTION_TYPES_SETTINGS',
    SET_ACTIVE_TAB: 'powertrainAssetsOverviewV2/SET_ACTIVE_TAB',
    TOGGLE_CONDITION_STATUS_FILTER: 'powertrainAssetsOverviewV2/TOGGLE_CONDITION_STATUS_FILTER',
    SET_ASSET_TYPES_FILTER: 'powertrainAssetsOverviewV2/SET_ASSET_TYPES_FILTER',
    SET_SEARCHBOX_FILTER: 'powertrainAssetsOverviewV2/SET_SEARCHBOX_FILTER',
    SET_SENSOR_IDENTIFIER_FILTER: 'powertrainAssetsOverviewV2/SET_SENSOR_IDENTIFIER_FILTER',
    SET_SUBSCRIPTION_TYPE_FILTER: 'powertrainAssetsOverviewV2/SET_SUBSCRIPTION_TYPE_FILTER',
    RESET_FILTERS: 'powertrainAssetsOverviewV2/RESET_FILTERS',
    CLEAR_ASSET_OVERVIEW: 'powertrainAssetsOverviewV2/CLEAR_ASSET_OVERVIEW',
    CLEAR_ASSET_GROUP_OVERVIEW: 'powertrainAssetsOverviewV2/CLEAR_ASSET_GROUP_OVERVIEW',
    PREVIOUS_SEARCH_FILTER: 'powertrainAssetsOverviewV2/UPDATE_SEARCH_FILTER',
    CLEAR_POWERTRAIN_OVERVIEW: 'powertrainAssetsOverviewV2/CLEAR_POWERTRAIN_OVERVIEW',
    UPDATE_SELECTED_FILTERS: 'powertrainAssetsOverviewV2/UPDATE_SELECTED_FILTERS',
    REFRESH_SELECTED_FILTERS: 'powertrainAssetsOverviewV2/REFRESH_SELECTED_FILTERS',
    CLEAR_STORE: 'powertrainAssetsOverviewV2/CLEAR_STORE',
    UPDATE_ASSET_NAME: 'powertrainAssetsOverviewV2/UPDATE_ASSET_NAME',
    SET_UPDATED_POWERTRAIN: 'powertrainAssetsOverview/SET_UPDATED_POWERTRAIN',

    LOAD_ASSET_CONDITION_INDICES_REQUEST: 'powertrainAssetsOverviewV2/LOAD_ASSET_CONDITION_INDICES_REQUEST',
    LOAD_ASSET_GROUP_CONDITION_INDICES_REQUEST: 'powertrainAssetsOverviewV2/LOAD_ASSET_GROUP_CONDITION_INDICES_REQUEST',
    LOAD_POWERTRAIN_CONDITION_INDICES_REQUEST: 'powertrainAssetsOverviewV2/LOAD_POWERTRAIN_CONDITION_INDICES_REQUEST',

    SET_SELECTED_ASSET: 'powertrainAssetsOverviewV2/SET_SELECTED_ASSET',
    SET_SELECTED_ASSET_DETAILS: 'powertrainAssetDetails/SET_SELECTED_ASSET',
    SET_NAVIGATION_SEARCH: 'powertrainAssetsOverviewV2/SET_NAVIGATION_SEARCH',

    SAVE_ASSET_OVERVIEW_SCROLL_TOP: 'powertrainAssetsOverviewV2/SAVE_ASSET_OVERVIEW_SCROLL_TOP',

    //Hierarchy view
    SET_CONDITION_INDICES_VIEW: 'powertrainAssetsOverviewV2/SET_CONDITION_INDICES_VIEW',
    GET_HIERARCHY_VIEW_REQUEST: 'powertrainAssetsOverviewV2/GET_HIERARCHY_VIEW_REQUEST',
    GET_LIST_VIEW_REQUEST: 'powertrainAssetsOverviewV2/GET_LIST_VIEW_REQUEST',
    GET_HIERARCHY_CONDITION_INDICES_SETTINGS: 'powertrainAssetsOverviewV2/GET_HIERARCHY_CONDITION_INDICES_SETTINGS',
};

export const toggleButtonOptions = {
    POWERTRAINS: 'Powertrains',
    ASSETGROUPS: 'AssetGroups',
    ASSETS: 'Assets'
};

export const assetActive = {
    ACTIVE: 'active'
};

export const pageSize = 500;

export const conditionIndices = {
    TOLERABLE: 'Tolerable',
    GOOD: 'Good',
    POOR: 'Poor',
    UNSUPPORTED: 'Unsupported',
    UNKNOWN: 'Unknown',
    ALARM: 'Alarm',
    ALERT: 'Alert'
};

export const conditionPriority = {
    Poor: 1,
    Tolerable: 2,
    Good: 3,
    Unknown: 4
};

export const MAX_CHAR_LENGTH = 30;

export const getTabOptionNames = {
    POWERTRAINS: 'powertrains',
    ASSETGROUPS: 'assetGroups',
    ASSETS: 'assets'
};

export const LEFT_PANEL_WIDTH_PERCENT = 40;

export const conditionIndicesViewOptions = {
    LIST: 'list',
    HIERARCHY: 'hierarchy'
};

export const assetDataKeys = {
    ASSETS: 'assets',
    NOT_CONFIGURED_ASSETS: 'notConfiguredAssets'
};

export const toggleOptions = {
    EXPAND: 'expand',
    COLLAPSE: 'collapse'
};

// State keys for condition indices
export const stateKeys = {
    ASSETS: 'assets',
    ASSET_GROUPS: 'assetGroups',
    POWERTRAINS: 'powertrains',
    HIERARCHY: 'hierarchy',
    SUBSCRIPTION_TYPES: 'subscriptionTypes'
};

// Filter property names
export const filterProperties = {
    ASSET_TYPE_FILTER: 'assetTypeFilter',
    CONDITION_FILTER: 'conditionFilter',
    SUBSCRIPTION_TYPE_FILTER: 'subscriptionTypeFilter',
    SENSOR_IDENTIFIER_FILTER: 'sensorIdentifierFilter',
    SEARCH_BOX: 'searchBox'
};

// State nested property names
export const stateProperties = {
    DATA: 'data',
    FILTER: 'filter',
    LOADING_STATUS: 'loadingStatus',
    INITIAL_LOAD_DONE: 'initialLoadDone'
};

export const WALKABLE_KEYS = ['items', 'assets', 'notConfiguredAssets', 'powertrains', 'notConfiguredPowertrains', 'locations', 'subLocations', 'sites', 'subOrganizations'];

export const scrollIntoViewOptions = {
    SELECTED_ASSET: {
        block: 'nearest',
        behavior: 'smooth'
    }
};
